import { CSSObject } from '@emotion/react';
import { TypographyStyleClasses } from '../../theming';

const getTextDecorationStyles = (underline?: boolean, lineThrough?: boolean): CSSObject => {
    const styles = [];
    if (underline) {
        styles.push('underline');
    }
    if (lineThrough) {
        styles.push('line-through');
    }
    return { textDecoration: styles.length > 0 ? styles.join(' ') : undefined };
};

export interface TypographyStylesParams {
    italic?: boolean;
    underline?: boolean;
    lineThrough?: boolean;
    align?: React.CSSProperties['textAlign'];
    transform?: React.CSSProperties['textTransform'];
    lineHeight?: React.CSSProperties['lineHeight'];
}

export function useStyles({ italic, underline, lineThrough, align, transform, lineHeight }: TypographyStylesParams): {
    styles: { [key in TypographyStyleClasses]: CSSObject };
} {
    const root: CSSObject = {
        ...getTextDecorationStyles(underline, lineThrough),
        fontStyle: italic ? 'italic' : undefined,
        textAlign: align || undefined,
        ...(transform ? { textTransform: transform } : null),
        ...{ lineHeight },
    };

    return {
        styles: {
            root,
        },
    };
}
